var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewProductMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H104L0 104V0Z",
    fill: "#E7672B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8986 38.7196L27.9473 47.7684L26.1885 49.5272L17.6867 46.7057L23.3484 52.3674L21.6206 54.0951L12.5719 45.0463L14.3058 43.3124L22.8947 46.1712L17.1708 40.4474L18.8986 38.7196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2546 35.3636L31.3033 44.4124L29.4948 46.2209L20.446 37.1722L22.2546 35.3636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5424 36.1654L38.0464 37.6693L34.1124 41.6033L32.6084 40.0993L36.5424 36.1654ZM25.6292 31.989L34.6779 41.0378L32.857 42.8587L23.8083 33.8099L25.6292 31.989ZM32.1361 32.8156L33.5966 34.2761L30.1909 37.6818L28.7304 36.2213L32.1361 32.8156ZM28.9852 28.633L30.4954 30.1432L26.5738 34.0648L25.0636 32.5546L28.9852 28.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1248 23.4934L35.9396 21.6786L42.1544 27.8935C42.8504 28.5895 43.2896 29.2856 43.4719 29.9816C43.6542 30.6694 43.6231 31.3385 43.3787 31.989C43.1301 32.6353 42.7178 33.2465 42.1419 33.8224C41.5619 34.4024 40.9466 34.8188 40.2961 35.0716C39.6415 35.3201 38.9703 35.3533 38.2825 35.171C37.5948 34.9804 36.9028 34.5371 36.2068 33.841L29.992 27.6262L31.8067 25.8115L38.0215 32.0263C38.4151 32.4199 38.7611 32.6789 39.0594 32.8032C39.3618 32.9233 39.6374 32.9378 39.886 32.8467C40.1345 32.7472 40.3852 32.5711 40.6379 32.3184C40.8948 32.0615 41.0688 31.8129 41.16 31.5726C41.2511 31.324 41.2346 31.0506 41.1103 30.7523C40.9901 30.4498 40.7332 30.1018 40.3396 29.7082L34.1248 23.4934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8714 26.1347L40.6255 16.9927L41.5826 16.0356L43.0617 16.943L49.3635 26.3522L48.3257 27.3901L46.8714 26.1347ZM38.6803 18.9379L47.5612 25.4821L48.6985 27.0172L47.555 28.1607L36.8842 20.734L38.6803 18.9379ZM50.6003 22.3809L44.0809 13.5373L45.8708 11.7474L53.3099 22.4058L52.1602 23.5555L50.6003 22.3809ZM42.1357 15.4825L51.3336 21.7594L52.5269 23.1888L51.489 24.2267L42.0736 17.9063L41.1848 16.4334L42.1357 15.4825Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProductMark);
export default __webpack_public_path__ + "static/media/new-product-mark.08bbcf566d2c776f2e8d5dd746be5dca.svg";
export { ForwardRef as ReactComponent };